// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grayed-text[data-v-826a7230] {\n  color: #6C7C7B;\n}", ""]);
// Exports
module.exports = exports;
